import baseStoreDefaults from '../witchdoctors/config.js';

export default {
  ...baseStoreDefaults,
  includes: ['shopify-generic', 'witchdoctors'],
  Widgets: [
    ...baseStoreDefaults.Widgets.filter(
      (w) => !['Facets', 'FacetDialog', 'SearchBox', 'SearchBoxDialogButton'].includes(w.name),
    ),
    {
      ...baseStoreDefaults.Widgets.find((w) => w.name === 'Facets'),
      initExpandedFacets: ['Shop by', 'product_type'],
    },
    {
      ...baseStoreDefaults.Widgets.find((w) => w.name === 'FacetDialog'),
      initExpandedFacets: ['Shop by', 'product_type'],
    },
    {
      name: 'SearchBox',
      type: 'SearchBoxDialogButton',
      location: {
        selector: '#cm-search-box',
        class: 'cm-search-box cm_mobile-hide',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        selector: '#cm-mobile-search-box',
        class: 'cm-mobile-search-box cm_desktop-hide',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'SearchBoxTablet',
      type: 'SearchBoxDialogButton',
      location: {
        selector: '#cm-tablet-search-box',
        class: 'cm-tablet-search-box cm_desktop-hide',
      },
      template: 'searchBox/dialogButtonMobile',
    },
  ],
};
